import { render } from "./PageBottom.vue?vue&type=template&id=0c676e28&scoped=true"
import script from "./PageBottom.vue?vue&type=script&lang=js"
export * from "./PageBottom.vue?vue&type=script&lang=js"

import "./PageBottom.vue?vue&type=style&index=0&id=0c676e28&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c676e28"]])

export default __exports__